import { render, staticRenderFns } from "./MenuAdm.vue?vue&type=template&id=f989770c&scoped=true"
import script from "./MenuAdm.vue?vue&type=script&lang=js"
export * from "./MenuAdm.vue?vue&type=script&lang=js"
import style0 from "./MenuAdm.vue?vue&type=style&index=0&id=f989770c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f989770c",
  null
  
)

export default component.exports